import styles from "./ChoiceGroup.module.scss";

function ChoiceGroup({ legend, name, value, options, onChange, error, status, variant = "cards", disabled = false, hint }) {
  const describedBy = [error ? `${name}-error` : "", hint ? `${name}-hint` : ""].filter(Boolean).join(" ") || undefined;

  return (
    <fieldset
      className={`${styles.group} ${styles[variant]} ${status ? styles[status] : ""}`}
      aria-describedby={describedBy}
      aria-invalid={Boolean(error)}
      tabIndex={error ? -1 : undefined}
      disabled={disabled}
    >
      <legend><span aria-hidden="true">*</span>{legend}</legend>
      <div className={styles.options}>
        {options.map((option) => (
          <label key={option.value}>
            <input
              type={variant === "plain" ? "checkbox" : "radio"}
              name={name}
              value={option.value}
              data-choice={variant === "plain" ? "true" : undefined}
              checked={value === option.value}
              onChange={onChange}
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
      {error ? (
        <span id={`${name}-error`} className={styles.error} role="alert">
          {error}
        </span>
      ) : null}
      {hint ? <span id={`${name}-hint`} className={styles.hint}>{hint}</span> : null}
    </fieldset>
  );
}

export default ChoiceGroup;
